import { useState } from "react";
import { itemDataFromDynamo } from "../contexts/UserDataContext";

export function calculateParentPath(
  itemMap: Record<string, itemDataFromDynamo>,
  curParent: string,
  item?: itemDataFromDynamo | {}
): string[] {

  if(item != undefined && Object.keys(item).length > 0) curParent = (item as itemDataFromDynamo).ParentId;

  if (Object.keys(itemMap).length > 0) {
    let parentPath: string[] = [];
    while (curParent != "MASTER") {
      // Check if parent exists in itemMap before adding to path
      if (!itemMap[curParent]) {
        // Parent doesn't exist (e.g., new unsaved item), stop traversal
        break;
      }
      parentPath.push(curParent);
      curParent = itemMap[curParent].ParentId;
    }
    parentPath.push("MASTER");
    parentPath = parentPath.reverse();
    return parentPath;
  }
  return [];
}

export function oldCalculateChildren(
  parentMap: Record<string, Set<string>>,
  curParent: string,
  allChildren: string[] = []
): string[] {
  if (Object.keys(parentMap).length > 0) {
    let curChildren = parentMap[curParent];
    if (curChildren != null) {
      curChildren.forEach((x: string) => {
        allChildren.push(x);
        oldCalculateChildren(parentMap, x, allChildren).forEach((element) => {});
      });
    }
    return allChildren;
  }
  return [];
}

export function calculateChildren(
  parentMap: Record<string, Set<string>>,
  curParent: string,
  allChildren: Set<string> = new Set()
): string[] {
  const curChildren = parentMap[curParent];
  if (!curChildren) return Array.from(allChildren);

  for (const child of curChildren) {
    if (!allChildren.has(child)) {
      allChildren.add(child);
      calculateChildren(parentMap, child, allChildren);
    }
  }

  return Array.from(allChildren);
}

export function getImmediateChildren(
  parentMap: Record<string, Set<string>>,
  curParent: string
): string[] {
  const curChildren = parentMap[curParent];
  return curChildren ? Array.from(curChildren) : [];
}